import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'countryAddressPopup-popover',
  templateUrl: 'countryAddressPopup.html',
  styleUrls: ['countryAddressPopup.scss'],

})

export class countryAddressPopup implements OnInit {

 
  public countryAddressData: any;
  public countryAddressDataCopy: any;
  


  constructor(public navParams: NavParams, private popoverController: PopoverController) {
  }

  ngOnInit() {

    this.countryAddressData = this.navParams.data.countryData;
    this.countryAddressDataCopy = this.navParams.data.countryData;
    
  }

  searchCountry(search) {
    const term = (search || "").toString().toLowerCase().trim();
    this.countryAddressData = this.countryAddressDataCopy;
    if (!term) {
      return;
    }

    this.countryAddressData = this.countryAddressData.filter(item => {
      return item.displayName.toLowerCase().includes(term) || (item.phoneCode + "").includes(term);
    });
  }

  addToCartClicked(country) {
   
    this.popoverController.dismiss(country);
  }

}

